/**
 * @file   src\components\Teaxtarea.tsx
 * @brief  Html Textarea component.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useEffect, useRef } from 'react';
import '../components/CWInput.scss';
import { ITextAreaProperty } from '../interfaces/generalInterface';

const CWTextarea = ({ rows, label, errorMessage, value, id, name, placeholder, disabled, maxLength, helptext, autoFocus, onChange }: ITextAreaProperty) => {
  const textareaRef: any = useRef(null);

  useEffect(() => {
    if (autoFocus) {
      textareaRef.current.focus();
    }
  }, [autoFocus]);

  return (
    <div className="form-group cw-input">
      <div className="cust-label-group">
        <label htmlFor="label">{label}
          {<span className="mandatory">*</span>}
        </label>
        <textarea
          className={errorMessage && errorMessage !== '' ? 'form-control error' : value && value !== '' ? 'form-control active' : 'form-control'}
          id={id}
          name={name}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          onChange={(event) => onChange && onChange(event)}
          ref={textareaRef}
          rows={rows}
        />
        <small className="help-text">{helptext}</small>
        {errorMessage && errorMessage !== '' && <span className="error-msg">{errorMessage}</span>}
      </div>
    </div>
  );
};

export default CWTextarea;
